// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1LrXu","close":"styles_close__4qrt1","btn-cancel":"styles_btn-cancel__2vwgb"};